import { reduxForm, formValueSelector } from 'redux-form';
import { connect } from 'react-redux';

import { fetchSalesOrderDetail } from '../../actions/sales_actions';
import { fetchSalesOrdersByDate, convertToInvoice } from '../../actions/dispatch_actions';

import Shipping from '../../components/Dispatch/shipping';

const shipping = reduxForm({
  form: 'shipping',
  // validate
})(Shipping);

const selector = formValueSelector('shipping');

function mapStateToProps(state) {
  const chosenOrderNum = selector(state, 'Sales_Order_No');
  const ShippingDate = selector(state, 'ShippingDate');

  return {
    chosenOrderNum,
    ShippingDate,

    salesOrders: state.dispatch.salesOrders,
    salesOrdersIsLoading: state.dispatch.salesOrdersIsLoading,
    salesOrdersError: state.dispatch.salesOrdersError,

    salesOrderDetail: state.salesOrders.currentSalesOrderDetail,
    salesOrderIsLoading: state.salesOrders.detailIsLoading,
    salesOrderError: state.salesOrders.detailError,
  };
}

export default connect(mapStateToProps, { fetchSalesOrderDetail, fetchSalesOrdersByDate, convertToInvoice })(shipping);



// WEBPACK FOOTER //
// ./master/jsx/containers/Dispatch/shipping.jsx